'use strict';

import $config from '@/config';

export default {
  isAdmin: state => {
    return state.session.role === 'admin';
  },
  isInfo: state => {
    return state.session.role === 'info' || state.session.role === 'admin';
  },
  hasPermission: (state) => (value) => {
    return (state.session.member & 15) === value;
  },
  hasShipments: (state) => () => {
    return (state.session.member & 15) > 0;
  },
  hasPartnerPermission:(state)=> () => {
  return (state.session.member & $config.PERMISSION.PARTNER_REPORT) === $config.PERMISSION.PARTNER_REPORT;
},
  hasTradeSOPermission:(state)=> () => {
    return (state.session.member & $config.PERMISSION.TRADE_SO) === $config.PERMISSION.TRADE_SO;
  },
  hasSourcePermission:(state)=>(value)=>{
    return (state.session.member & value) ===value;
  },
  isMasterAccount:(state) => {
    return state.session.companyRole === 'admin';
  },
  getSession:(state) => {
    return state.session;
  },
  getDefaultEmailModel(state){
   return _.filter(state.emailModel,function(o){
      return o.isDefault === 1;
    });
  }
};



// WEBPACK FOOTER //
// ./src/store/getters.js